import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withPrimeContext from "../withPrimeContext";
import { RefundableFlightsBanner } from "~/components/acquisition/RefundableFlightsBanner/";

export default withPrimeContext(
  withErrorBoundary(RefundableFlightsBanner, {
    name: "RefundableFlightsBanner",
  }),
);
